import { render, staticRenderFns } from "./ModalUserAddEdit.vue?vue&type=template&id=125d0250&scoped=true&"
import script from "./ModalUserAddEdit.vue?vue&type=script&lang=js&"
export * from "./ModalUserAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModalUserAddEdit.vue?vue&type=style&index=0&id=125d0250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125d0250",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VSelect,VTextField})
